import { memo } from 'react';
import classNames from 'classnames';

import ClockIcon from '../../../../../assets/icons/clock.svg';
import { TimerDisplay } from './timer-display';
import { useOptimizedCountdown } from '@utils/hooks/use-optimized-countdown';

import styles from '../index.module.css';

export enum DiscountVariant {
  RED = 'red',
  PURPLE = 'purple',
}

type DiscountBannerProps = {
  variant: DiscountVariant;
  onFinish?: () => void;
  targetTime: number;
  className?: string;
};

const VARIANT_CONFIG = {
  [DiscountVariant.RED]: {
    className: styles.redVariant,
    timerEndClassName: '',
    prefix: 'This offer ends in',
  },
  [DiscountVariant.PURPLE]: {
    className: styles.purpleVariant,
    timerEndClassName: styles.discountSectionTimerEnd,
    prefix: 'This offer is available within',
  },
} as const;

export const DiscountBanner = memo(
  ({ variant, onFinish, targetTime, className }: DiscountBannerProps) => {
    const { minutes, seconds, isComplete } = useOptimizedCountdown({
      targetDate: targetTime,
      onComplete: onFinish,
    });

    const config = VARIANT_CONFIG[variant];

    const bannerClassName = classNames(
      styles.discountSection,
      config.className,
      {
        [config.timerEndClassName]: isComplete && config.timerEndClassName,
      },
      className,
    );

    return (
      <div className={bannerClassName}>
        <ClockIcon width={20} height={20} />
        <TimerDisplay
          minutes={minutes}
          seconds={seconds}
          isTimerEnd={isComplete}
          endMessage="Special offer just for you!"
          prefix={isComplete ? undefined : config.prefix}
        />
      </div>
    );
  },
);

DiscountBanner.displayName = 'DiscountBanner';
